document.addEventListener('DOMContentLoaded', function () {
    // 预加载所有图片
    document.querySelectorAll('.pdp-img-slider img[data-srcset]').forEach(function(img){
        var realSrc = img.getAttribute('data-srcset');
        if(realSrc){
            img.setAttribute('src', realSrc);
        }
    });

    document.querySelectorAll('.pdp-img-tab').forEach(function(tabWrap) {
      var tabs = tabWrap.querySelectorAll('.tab-list .tab-item');
      var contents = tabWrap.querySelectorAll('.tab-content .tab-item-content');
      var points = tabWrap.querySelectorAll('.selling-points .point');
      var images = tabWrap.querySelectorAll('.pdp-img-slider .img-item');
      tabs.forEach(function(tab, idx) {
        tab.addEventListener('click', function() {
          // 切换tab激活状态
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          // 切换内容
          contents.forEach(c => c.classList.remove('active'));
          if(contents[idx]) contents[idx].classList.add('active');
          points.forEach(c => c.classList.remove('active'));
          if(points[idx]) points[idx].classList.add('active');
          // 切换图片
          images.forEach(i => i.classList.remove('active'));
          if(images[idx]) images[idx].classList.add('active');
        });
      });
    });
  });